// FT-200 STEP-05 (REQ-08, DEC-01): «Добавить в календарь» в кабинете клиента — файл .ics из calendar_ics ответа.
// Веб — скачивание (file-saver), нативное приложение — файл в Documents и «Поделиться» (как downloadIcalendar
// карточки бронирования). calendarIO — шов для спеков: зависимости подменяются на объекте, модуль не мокается.
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Share } from "@capacitor/share";
import { saveAs } from "file-saver";

export const calendarIO = {
  isNative: () => Capacitor.isNativePlatform(),
  saveAs: (blob, name) => saveAs(blob, name),
  writeFile: (options) => Filesystem.writeFile(options),
  share: (options) => Share.share(options),
};

function dataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new window.FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

// Отказ записи или «Поделиться» — без исключения наружу: клиент остаётся в кабинете и может повторить.
export function saveCalendar(ics, name, title) {
  if (!ics) return Promise.resolve(false);
  const blob = new window.Blob([ics], { type: "text/calendar" });
  if (!calendarIO.isNative()) {
    calendarIO.saveAs(blob, name);
    return Promise.resolve(true);
  }
  return dataUrl(blob)
    .then((data) => calendarIO.writeFile({ path: name, data, directory: Directory.Documents }))
    .then((file) => calendarIO.share({ title, files: [file.uri] }))
    .then(() => true)
    .catch(() => false);
}
